export const theme = {
    color : {
        main : '#f95f53',
        title : '#3f3f3f'
    }
}